module.exports = new __parcel__URL__("13239_sq.422a65eb.jpg").toString();